import type { InFieldCDMLocationConfig } from '../../cdm-types';
import type { RootLocationConfiguration } from '../../types';

/**
 * Transforms the CDM-specific location config format into the common
 * RootLocationConfiguration format used throughout the application.
 *
 * @param locationConfig - The CDM InField location configuration to map
 * @returns The mapped root location configuration, or undefined if required
 *          fields (dataStorage.rootLocation.externalId or space) are missing
 */
export const mapInfieldLocationConfigToRootLocationConfig = (
  locationConfig: InFieldCDMLocationConfig
): RootLocationConfiguration | undefined => {
  const rootLocation = locationConfig.dataStorage?.rootLocation;

  if (!rootLocation || !rootLocation.externalId || !rootLocation.space) {
    return undefined;
  }

  return {
    externalId: locationConfig.externalId,
    assetExternalId: rootLocation.externalId,
    sourceDataInstanceSpace: rootLocation.space, // This is used in checklist filter as a root location filter this is used as a fallback in useChecklistsListWithFdmFilters
    appDataInstanceSpace: locationConfig.dataStorage?.appInstanceSpace,
    dataFilters: undefined, // dataFilters are set to undefined because dataFilters is only used in appConfigFilterProvider, in which we are building a new version of that provider and it will use the new configuration.
    displayName: locationConfig.name,
    templateAdmins: locationConfig.accessManagement?.templateAdmins,
    checklistAdmins: locationConfig.accessManagement?.checklistAdmins,
    featureToggles: {
      ...locationConfig.featureToggles,
      observations: locationConfig.featureToggles?.observations // TODO(FO-2880): Figure Out Observations
        ? {
            isEnabled: locationConfig.featureToggles.observations,
            isWriteBackEnabled: false,
            attachmentsEndpointExternalId: '',
            notificationsEndpointExternalId: '',
          }
        : undefined,
    },
    threeDConfiguration: {
      fullWeightModels: [],
    },
  };
};
